import classes from './Paneli.module.css';

const Paneli = ({ slika, handleClick, listaPanela }) => {
  return (
    <div
      className={classes.snippets}
      style={{ marginBottom: '10px', marginTop: '10px' }}
    >
      {listaPanela.map((item, index) => (
        <div
          key={index}
          className={classes.snippet}
          style={{
            backgroundColor: item.bgColor,
            display: 'flex',
            justifyContent: 'space-between',
          }}
          onClick={item.handleClick}
        >
          <div>
            <span
              className={classes.snippetItem}
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '18px',
                color: item.colorText,
              }}
            >
              {item.naslov} {item.suma}
            </span>
          </div>
          {/* <img
            src={slika}
            style={{ width: '30px', height: '30px' }}
            alt="Wallet icon"
          /> */}
          {/* <i
        className="far fa-clock"
        style={{ fontSize: '30px', color: 'white' }}
      /> */}
        </div>
      ))}
    </div>
  );
};

export default Paneli;
